import { render } from "./ProductTagCloud.vue?vue&type=template&id=5baf5eb9&scoped=true"
import script from "./ProductTagCloud.vue?vue&type=script&lang=js"
export * from "./ProductTagCloud.vue?vue&type=script&lang=js"

import "./ProductTagCloud.vue?vue&type=style&index=0&id=5baf5eb9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5baf5eb9"]])

export default __exports__